/*
 * @Author: mayanxia 
 * @Date: 2022-05-07 08:43:16 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2024-01-02 16:46:56
 */

<template>
  <j-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    :bodyStyle="bodyStyle"
    :cancelText="$t('关闭')">
    <template slot="footer">
      <a-button key="close" @click="handleCancel">
        {{ $t('关闭') }}
      </a-button>
    </template>
    <a-spin :spinning="confirmLoading">
       <div class="form-contain" style="height: auto">
        <a-tabs v-model="activeKey" @change="changeTab">
          <a-tab-pane v-for="item in tabList" :key="item.key" :tab="item.title">
            <div v-if="activeKey == 1" style="height: calc(70vh - 90px);overflow-y: auto;">
              <detail-list :col="2" size="small">
                <detail-list-item :term="$t('设备编号')">{{model.meterId}}</detail-list-item>
                <detail-list-item :term="$t('SIM卡号')">{{model.meterSim}}</detail-list-item>
                <detail-list-item :term="$t('上传时间')">{{model.createTime}}</detail-list-item>
                <detail-list-item :term="$t('表端时间')">{{model.meterTime}}</detail-list-item>
                <detail-list-item :term="$t('表类型')">{{meterTypeName}}</detail-list-item>
                <detail-list-item :term="$t('阀门状态')">{{model.meterValveStatus==null?'--':model.meterValveStatus==1?$t('关阀'):$t('开阀')}}</detail-list-item>
                <detail-list-item :term="$t('硬件版本号')">{{model.hardwareVersion}}</detail-list-item>
                <detail-list-item :term="$t('软件版本号')">{{model.softwareVersion}}</detail-list-item>
                <detail-list-item :term="$t('阀门开度')">{{model.valveOpening==null?'--':model.valveOpening}}</detail-list-item>
                <detail-list-item :term="$t('电压值(V)')">{{model.meterBatteryVoltage}}</detail-list-item>
                <detail-list-item :term="$t('CSQ(信号指示)')">{{meterSignal.signalCsq}}</detail-list-item>
                <detail-list-item :term="$t('RSRP(信号强度)')">{{meterSignal.signalRsrp}}</detail-list-item>
                <detail-list-item :term="$t('RSRQ(信号质量)')">{{meterSignal.signalRsrq}}</detail-list-item>
                <detail-list-item :term="$t('SNR(信噪比)')">{{meterSignal.signalSnr}}</detail-list-item>
              </detail-list>
            </div>
            <a-table
              v-else-if="activeKey != 1"
              ref="table"
              size="middle"
              :scroll="{y:'calc(60vh - 190px)'}"
              bordered
              rowKey="id"
              :columns="columns"
              :dataSource="dataSource"
              :pagination="ipagination"
              :loading="loading"
              class="j-table-force-nowrap"
              @change="handleTableChange"
              >
            </a-table>
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-spin>
  </j-modal>
</template>

<script>

  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  export default {
    name: 'PartValveUpDataLastRecordModal',
    mixins:[JeecgListMixin],
    components: {
      DetailList,
      DetailListItem
    },
    data () {
      return {
        bodyStyle: {
          height: '60vh',
          'overflow-y': 'hidden'
        },
        width:800,
        visible: false,
        disableSubmit: false,
        model: {},
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/jeecg-charge/meter/partValveUpDataLastRecord/add",
          edit: "/jeecg-charge/meter/partValveUpDataLastRecord/edit",
          queryById: "/jeecg-charge/meter/partValveUpDataLastRecord/queryById",
          list: "/jeecg-charge/part/partValveUpDataRecord/list"
        },
        meterSignal: {},
        activeKey: 1,
        disableMixinCreated: true,
        uniqueParam: {},
      }
    },
    computed: {
      title() {
        return this.$t('详情')
      },
      tabList() {
        return [
          {key: 1,title: this.$t('基本信息')},
          {key: 2,title: this.$t('历史数据')}
        ]
      },
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('设备编号'),
            align:"center",
            dataIndex: 'meterId'
          },
          {
            title: this.$t('阀门开度'),
            align:"center",
            dataIndex: 'valveOpening',
            customRender: (t,r,index) => {
              return t==null?'--':t;
            }
          },
          {
            title: this.$t('阀门状态'),
            align:"center",
            dataIndex: 'meterValveStatus',
            customRender: (t,r,index) => {
              return t==null?'--':t == 1? this.$t('关阀'): this.$t('开阀');
            }
          },
          {
            title: this.$t('电压(V)'),
            align:"center",
            dataIndex: 'meterBatteryVoltage'
          },
          {
            title: this.$t('表端时间'),
            align:"center",
            dataIndex: 'meterTime'
          },
          {
            title: this.$t('上报时间'),
            align:"center",
            dataIndex: 'createTime'
          }
        ]
      },
      meterTypeName() {
        if(this.model.meterType) {
          let meterType = parseInt(this.model.meterType).toString(16)
          return  filterDictTextByCache('valve_device_type',meterType);
        }
        
      }
    },
    created () {
    },
    methods: {
      close () {
        this.$emit('close');
        this.activeKey = 1;
        this.visible = false;
      },
      add () {
        this.edit({});
      },
      edit (record) {
        
        this.model = Object.assign({}, record);
        let meterSignalStrength = record.meterSignalStrength
        this.meterSignal = JSON.parse(meterSignalStrength)
        this.uniqueParam.deviceId = this.model.meterId
        this.visible = true;
      },
      handleOk () {
        const that = this;
      },
      handleCancel () {
        this.close()
      },
      changeTab() {
        if(this.activeKey == 2) {
          this.loadData(1)
        }
      }
    }
  }
</script>